import { useState, useEffect } from 'react';
import { FamilyMember } from '@/types';
import { useFamilyStore } from '@/store/familyStore';
import { searchMembers } from '@/utils/family/search';
import { MemberSearchInput } from './MemberSearchInput';
import { MemberSearchResults } from './MemberSearchResults';

interface MemberSearchProps {
  onSelect: (memberId: string) => void;
  placeholder?: string;
  className?: string;
  excludeId?: string;
}

export function MemberSearch({ 
  onSelect, 
  placeholder, 
  className,
  excludeId 
}: MemberSearchProps) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Array<{ member: FamilyMember; lineage: string }>>([]);
  const { members } = useFamilyStore();

  useEffect(() => {
    if (query.length >= 2) {
      const searchResults = searchMembers(query, members, excludeId);
      setResults(searchResults);
    } else {
      setResults([]);
    }
  }, [query, members, excludeId]);

  const handleSelect = (member: FamilyMember) => {
    onSelect(member.id);
    setQuery(member.name);
    setResults([]);
  };

  return (
    <div className={`relative ${className}`}>
      <MemberSearchInput
        value={query}
        onChange={setQuery}
        placeholder={placeholder}
      />
      <MemberSearchResults
        results={results}
        onSelect={handleSelect}
      />
    </div>
  );
}